import Constants from "expo-constants";
import {
  NODE_ENV as nodeEnv,

  BASE_URI as baseUri,
  PUSHER_APP_ID as appId,
  PUSHER_KEY as pusherKey,
  PUSHER_SECRET as pusherSecret,

  TEST_EMAIL,
  TEST_PASS,
} from "@env";

export const isDevelopment = nodeEnv === "development";

// TODO:  Find a new way to generate unique device IDs
export const DEVICE_UUID = Constants.installationId;

const envCreds = {
  BASE_URI: baseUri,
  PUSHER_APP_ID: appId,
  PUSHER_KEY: pusherKey,
  PUSHER_SECRET: pusherSecret,
};

export const BASE_URI = envCreds.BASE_URI;

export const PUSHER_APP_ID = envCreds.PUSHER_APP_ID;
export const PUSHER_KEY = envCreds.PUSHER_KEY;
export const PUSHER_SECRET = envCreds.PUSHER_SECRET;

export const DEFAULT_EMAIL = isDevelopment ?  TEST_EMAIL : ""
export const DEFAULT_PASS  = isDevelopment ? TEST_PASS : ""
export const NODE_ENV = nodeEnv;

console.log('\n')
// console.log('[ constants ]', PUSHER_APP_ID, PUSHER_KEY, PUSHER_SECRET, nodeEnv);
console.log('\n')
